module.exports = __webpack_public_path__ + "static/media/icon-mine-selected.741f211a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/icon-mine-selected.svg
// module id = 181
// module chunks = 0